import { NavigationItem } from '../../objects/navigationItem'

const navigationItems: NavigationItem[] = [
  {
    defaultIcon: <div />,
    hoverIcon: <div />,
    selectedIcon: <div />,
    redirectPath: '/',
    itemTitle: 'Dashboard',
    highlightedColor: '#f39029',
    subTab: [],
  },
  {
    defaultIcon: <div />,
    hoverIcon: <div />,
    selectedIcon: <div />,
    redirectPath: '/results',
    itemTitle: 'Results',
    highlightedColor: '#f39029',
    subTab: [],
  },
]

export default navigationItems
